/** SF-5087: an item's Jira tickets as links, one per key. */
import { Space } from 'antd';
import type { JiraLink } from '../api/prioritiesClient';

export const JiraLinks: React.FC<{ links?: JiraLink[] }> = ({ links = [] }) =>
  links.length > 0 ? (
    <Space size={4} wrap>
      {links.map((link) => (
        <a key={link.key} href={link.url} target="_blank" rel="noreferrer">
          {link.key}
        </a>
      ))}
    </Space>
  ) : null;
